import {
  ORGLIST,
} from '../actions/org';
import {reducerPackage} from "../../utils";

export const orgList = reducerPackage(ORGLIST);
